<template>
  <div class="identity" id="identity">
    <v-card flat="flat" class="nuclear">
      <v-card-title class="nuclear-title">
        Identity & Access Management
        <div class="button_group" v-if="profile.role == 1 || profile.role == 2">
          <div class="profile_btn">
            <v-btn
              :class="this.tabIndex == 1 ? 'active_btn' : 'default_btn'"
              @click="tabIndex = 1"
              >Profile</v-btn
            >
          </div>
          <div class="myteam_btn">
            <v-btn
              :class="this.tabIndex == 2 ? 'active_btn' : 'default_btn'"
              @click="tabIndex = 2"
              >My Teams</v-btn
            >
          </div>
        </div>
      </v-card-title>
      <user-profile v-if="this.tabIndex == 1"></user-profile>
      <my-teams v-else></my-teams>
    </v-card>
  </div>
</template>

<script>
import Vue from "vue";
import UserProfile from "./UserProfile";
import MyTeams from "./MyTeams";
Vue.component("user-profile", UserProfile);
Vue.component("my-teams", MyTeams);

export default {
  components: {
    UserProfile,
    MyTeams
  },

  data() {
    return {
      tabIndex: 1
    };
  },

  computed: {
    profile() {
      return this.$store.state.user.profile;
    }
  },

  mounted() {
    this.$store.dispatch("aboutMe");
    this.$store.dispatch("getAllUsers");
    this.$store.dispatch("getAllTimezones");
    this.$store.dispatch("getAllLanguages");
    // this.$store.dispatch('getAllUserRoles');
    this.$store.dispatch("getAllCountries");
    this.$store.dispatch("getAllTeams");
  }
};
</script>
